<template>
  <div>
    <el-card shadow="always">
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input size="small" style="width: 250px" placeholder="搜索名称关键字" clearable v-model.trim="params.keyword" @change="getData()">
            <el-button slot="append" icon="el-icon-search" @click="getData"></el-button>
          </el-input>
          <el-button size="mini" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
        </div>
        <el-button size="small" type="primary" @click="saveDialog()" v-if="$isPerm('bank-branches-save')">添加银行</el-button>
      </div>
    </el-card>
    <el-table height="600" size="small" :data="tableData.list" border row-key="id" @selection-change="handleSelectionChange" class="box-card mt10">
      <!-- <el-table-column type="selection" width="40"></el-table-column> -->
      <el-table-column prop="id" label="ID" width="50"> </el-table-column>
      <el-table-column prop="bank_name" label="银行名称" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.bank_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="征信类型" width="150">
        <template slot-scope="scope">
          <el-tag size="mini" type="success" v-if="scope.row.is_indiv == 1">个人征信</el-tag>
          <el-tag size="mini" type="success" v-if="scope.row.is_ent == 1" style="margin-left: 3px">企业征信</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="地址" show-overflow-tooltip width="250"></el-table-column>
      <el-table-column prop="work_time" label="营业时间" show-overflow-tooltip width="280">
        <template slot-scope="scope">
          <span>{{ scope.row.work_time }}</span
          ><el-tag size="mini" type="success" v-if="scope.row.is_24 == 1">全天自助</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
      <el-table-column prop="location" label="坐标" width="200"></el-table-column>
      <el-table-column label="创建时间" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time | date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="saveDialog(scope.row)" v-if="$isPerm('bank-branches-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="deleteData(scope.row.id)" v-if="$isPerm('bank-branches-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,sizes,prev, pager, next"
      :page-sizes="[15, 30, 50, 100]"
      :total="tableData.total"
      :page-size="tableData.page_size"
      :current-page="tableData.page"
      @current-change="pageChange"
      @size-change="pageSizeChange"
      class="box-card pd10 mt10"
    >
    </el-pagination>
    <el-dialog :title="saveDialogTitle" :visible.sync="saveDialogShow" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <div style="padding: 20px">
        <el-form size="small" ref="formRef" :model="formData" :rules="rules" label-width="120px">
          <el-form-item label="银行名称" prop="bank_name">
            <el-input v-model="formData.bank_name" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="征信类型" style="width: 280px">
            <div style="display: flex">
              <el-checkbox size="mini" v-model="formData.is_indiv" label="个人征信" :true-label="1" :false-label="0"></el-checkbox>
              <el-checkbox size="mini" v-model="formData.is_ent" label="企业征信" :true-label="1" :false-label="0"></el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="全天自助" style="width: 280px">
            <el-switch size="mini" v-model="formData.is_24" :active-value="1" :inactive-value="0"> </el-switch>
          </el-form-item>
          <el-form-item label="银行地址" prop="address" style="width: 280px">
            <el-input type="textarea" :rows="2" v-model="formData.address" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="营业时间" prop="work_time" style="width: 280px">
            <el-input v-model="formData.work_time" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="formData.phone" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item label="经纬度" prop="location">
            <el-input v-model="formData.location" placeholder="从《坐标拾取器》复制" style="width: 280px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-link type="primary" href="https://lbs.qq.com/getPoint/" target="_blank">《坐标拾取器》</el-link>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-but">
        <el-button type="primary" :loading="loading" @click="saveData()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'bankBranchesList',
  components: {},
  created() {
    this.getData();
  },
  data() {
    var validateLocation = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请从《坐标拾取器》获取坐标,粘贴进去'));
      } else {
        let arr = value.split(',');
        if (arr.length != 2) {
          callback(new Error('正确坐标格式:123.123456,234.123456'));
        }
        callback();
      }
    };
    return {
      saveDialogTitle: '添加银行网点',
      saveDialogShow: false,
      loading: false,
      tableData: {
        page: 0,
        page_count: 0,
        page_size: 0,
        total: 0,
        list: []
      },
      params: {
        page: 1,
        page_size: 15,
        keyword: ''
      },
      bank_names: '',
      formData: {
        id: 0,
        bank_name: '',
        address: '',
        work_time: '',
        phone: '',
        location: '',
        is_indiv: 1,
        is_ent: 0,
        is_24: 0
      },
      rules: {
        bank_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        location: [
          { required: true, message: '请从《坐标拾取器》获取坐标,粘贴进去', trigger: 'blur' },
          { validator: validateLocation, trigger: 'blur' }
        ]
      },
      num: 0,
      selectedIds: []
    };
  },
  methods: {
    //银行新增/编辑
    saveDialog(row) {
      this.saveDialogShow = true;
      this.saveDialogTitle = '添加银行网点';
      this.formData = {
        id: 0,
        bank_name: '',
        address: '',
        work_time: '',
        phone: '',
        location: '',
        is_indiv: 1,
        is_ent: 0,
        is_24: 0
      };
      if (row) {
        this.saveDialogTitle = '编辑银行网点';
        this.formData = _.cloneDeep(row);
      }
    },
    // 保存数据
    async saveData() {
      this.$refs.formRef.validate(async vaild => {
        if (!vaild) return;
        this.loading = true;
        let data = _.cloneDeep(this.formData);
        let location_arr = data.location.split(',');
        if (location_arr.length != 2) {
          this.$message.error('无效坐标');
          return;
        }
        data['lat'] = location_arr[0];
        data['lng'] = location_arr[1];
        await this.$api.bankBranches.saveData(data).then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.saveDialogShow = false;
            this.getData();
          }
        });
      });
    },
    //删除
    async deleteData(id) {
      if (this.selectedIds.length == 0 && !id) {
        this.$message.warning('未选中数据');
        return;
      }
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            ids: this.selectedIds.join(',')
          };
          if (id) {
            params.ids = id;
          }
          this.loading = true;
          await this.$api.bankBranches.deleteData(params).then(res => {
            this.loading = false;
            if (res.code != 200) return;
            this.$message.success(res.msg);
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 获取数据
    async getData() {
      let params = Object.assign({}, this.params);
      await this.$api.bankBranches.list(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    //多选
    handleSelectionChange(selectedItems) {
      let list = [];
      for (const val of selectedItems) {
        if (!list.includes(val.id)) {
          list.push(val.id);
        }
      }
      this.selectedIds = list;
    },
    // 分页切换
    pageChange(page) {
      this.params.page = page;
      this.getData();
    },
    // 分页大小切换
    pageSizeChange(pageSize) {
      this.params.page_size = pageSize;
      this.getData();
    },
    //刷新
    refresh() {
      this.getData();
    }
  }
};
</script>
